import { render, staticRenderFns } from "./MenuAvailabilityToast.vue?vue&type=template&id=1536ffcc&scoped=true"
import script from "./MenuAvailabilityToast.vue?vue&type=script&lang=js"
export * from "./MenuAvailabilityToast.vue?vue&type=script&lang=js"
import style0 from "./MenuAvailabilityToast.vue?vue&type=style&index=0&id=1536ffcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1536ffcc",
  null
  
)

export default component.exports